export default {
  common: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    support: 'Atención al cliente',
    privacy: 'Política de privacidad',
    terms: 'Condiciones de uso',
    and: 'y',
    guest: 'Invitado',
    play: 'Jugar',
    install: 'Instalar',
  },
  support: {
    title: '¿Necesitas ayuda?',
    description: `Si tienes algún problema con el juego,
      haremos todo lo posible por ayudarte y responder a todas tus preguntas.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Ayuda a Austin el mayordomo a devolverle el calor y el confort a su maravillosa mansión familiar.',
    description: `Ayuda a Austin el mayordomo a devolverle el calor y el confort
      a su maravillosa mansión familiar. Adelante, ¡te esperan aventuras
      nada más cruzar el umbral!`,
  },
  cookie: {
    message: 'Este sitio web utiliza cookies para proporcionarte la mejor experiencia posible.',
    link: 'Más información',
    button: 'Aceptar',
  },
  install: {
    title: '@:common.install',
    text: `¡Homescapes en tu ordenador!
    ¡Instala la versión web del juego y corre a ver a Austin con solo unos clics!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla es distribuidor global autorizado de Homescapes',
  },
  game: {
    notSupported: `No compatible con dispositivos móviles.
      Inicia sesión desde un ordenador para jugar.`,
  },
};
